import { render, staticRenderFns } from "./PainelAnexoVisualizacao.vue?vue&type=template&id=71ec3e01&scoped=true"
import script from "./PainelAnexoVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelAnexoVisualizacao.vue?vue&type=script&lang=js"
import style0 from "./PainelAnexoVisualizacao.vue?vue&type=style&index=0&id=71ec3e01&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ec3e01",
  null
  
)

export default component.exports